module.exports = __webpack_public_path__ + "static/Custom_Function_hires-310b6248bde6f2260dc5d9bdb0dd349a.jpg";